export default __webpack_public_path__ + "static/media/K.0728ba7d.svg";